import { createSelector } from '@reduxjs/toolkit'
import { servicesSlice } from '@/store/servicesSlice'
import { timeScheduleSlice } from '@/store/timeScheduleSlice'
import { serviceAmountSelector } from '@/store/timeScheduleSlice/selectors/serviceAmountSelector'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { cartSlice } from '..'

export const totalGlobalBoughtQuantitySelector = createSelector(
  [
    servicesSlice.selectors.data,
    cartSlice.selectors.selectedElementReservation,
    timeScheduleSlice.selectors.service,
    serviceAmountSelector,
  ],
  (
    services,
    selectedElementReservation,
    selectedService,
    serviceAmount
  ): number => {
    if (!services?.hasLimit || selectedElementReservation === null) {
      return 0
    }

    const ticketIds = services.ticketServices.map(
      (service) => service.serviceId
    )

    return (
      Object.entries(selectedElementReservation.boughtServices).reduce<number>(
        (total, entry) => {
          const [key, boughtService] = entry
          const serviceId = Number(key)

          if (ticketIds.includes(serviceId)) {
            if (serviceId === selectedService?.serviceId) {
              // NOOP: skip, use the serviceAmount instead
            } else {
              total += getBoughtServicesTotal(boughtService)
            }
          }

          return total
        },
        0
      ) + (serviceAmount ?? 0)
    )
  }
)
